export default class UserForm {
  constructor (username, email, password) {
    this.username = username
    this.email = email
    this.password = password
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/models/UserForm.js